/**
 * Constants for Reports module
 */

import type { ReactNode } from 'react';
import {
  BarChart3,
  LineChart as LineChartIcon,
  PieChart as PieChartIcon,
  Gauge,
  Grid3X3,
  Table as TableIcon,
  Activity,
  FileText,
  MapPin,
  TrendingUp,
  Layers,
} from 'lucide-react';

// Chart colors palette
export const CHART_COLORS = [
  '#3b82f6', // blue
  '#10b981', // emerald
  '#f59e0b', // amber
  '#ef4444', // red
  '#8b5cf6', // violet
  '#06b6d4', // cyan
  '#f97316', // orange
  '#84cc16', // lime
  '#ec4899', // pink
  '#6366f1', // indigo
];

// Report view types matching the legacy SupplierPortal_New chart picker
export const REPORT_VIEW_TYPES = [
  { value: 'grid', label: 'Grid/Table', icon: <TableIcon className="h-5 w-5" />, description: 'Tabular data view with sorting and filtering' },
  { value: 'bar', label: 'Bar Chart', icon: <BarChart3 className="h-5 w-5" />, description: 'Compare values across categories' },
  { value: 'line', label: 'Line Chart', icon: <LineChartIcon className="h-5 w-5" />, description: 'Show trends over time' },
  { value: 'pie', label: 'Pie Chart', icon: <PieChartIcon className="h-5 w-5" />, description: 'Show proportions of a whole' },
  { value: 'donut', label: 'Donut', icon: <PieChartIcon className="h-5 w-5" />, description: 'Pie chart with a hollow centre and total' },
  { value: 'kpi', label: 'KPI Dashboard', icon: <Gauge className="h-5 w-5" />, description: 'Key performance indicators' },
  { value: 'indicator', label: 'Indicator', icon: <Activity className="h-5 w-5" />, description: 'Single big-number indicator with target ring' },
  { value: 'summary', label: 'Summary', icon: <Grid3X3 className="h-5 w-5" />, description: 'Aggregated summary view' },
  { value: 'heatmap', label: 'Heatmap', icon: <Layers className="h-5 w-5" />, description: 'Two-dimensional matrix shaded by value' },
  { value: 'waterfall', label: 'Waterfall', icon: <TrendingUp className="h-5 w-5" />, description: 'Cumulative deltas with up/down stacks' },
  { value: 'geolocation', label: 'Geolocation', icon: <MapPin className="h-5 w-5" />, description: 'Values aggregated by country/region' },
  { value: 'markup', label: 'MarkUp', icon: <FileText className="h-5 w-5" />, description: 'Annotation card with HTML and links' },
];

// Chart type icons
export const CHART_TYPE_ICONS: Record<string, ReactNode> = {
  bar: <BarChart3 className="h-4 w-4" />,
  line: <LineChartIcon className="h-4 w-4" />,
  pie: <PieChartIcon className="h-4 w-4" />,
  donut: <PieChartIcon className="h-4 w-4" />,
  kpi: <Gauge className="h-4 w-4" />,
  indicator: <Activity className="h-4 w-4" />,
  summary: <Grid3X3 className="h-4 w-4" />,
  grid: <TableIcon className="h-4 w-4" />,
  heatmap: <Layers className="h-4 w-4" />,
  waterfall: <TrendingUp className="h-4 w-4" />,
  geolocation: <MapPin className="h-4 w-4" />,
  markup: <FileText className="h-4 w-4" />,
};
